export const isMobileDevice = () => window.innerWidth <= 800 && window.innerHeight >= 630;
